import { render, staticRenderFns } from "./imageUpload.vue?vue&type=template&id=38a89722&"
import script from "./imageUpload.vue?vue&type=script&lang=js&"
export * from "./imageUpload.vue?vue&type=script&lang=js&"
import style0 from "./imageUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports